module.exports = __webpack_public_path__ + "img/8.26f8df64.webp";